export const RESET_SIDEBAR_STATE = 'RESET_SIDEBAR_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SIDEBAR_AGENDA = 'SIDEBAR_AGENDA';
export const ENTITY_CHANNEL_SIDEBAR = 'ENTITY_CHANNEL_SIDEBAR';
export const LOCATION_SIDEBAR = 'LOCATION_SIDEBAR';
export const STRUCTURE_SIDEBAR = 'STRUCTURE_SIDEBAR';
export const EDIT_BLOCK_PULSE_SIDEBAR = 'EDIT_BLOCK_PULSE_SIDEBAR';
export const SIDEBAR_NODE_AI = 'SIDEBAR_NODE_AI';

export const resetSidebarState = (payload) => ({
  type: RESET_SIDEBAR_STATE,
  payload,
});

export const clearState = () => ({
  type: CLEAR_STATE,
});

export const sidebarAgenda = (payload) => ({
  type: SIDEBAR_AGENDA,
  payload,
});

export const entityChannelSidebar = (payload) => ({
  type: ENTITY_CHANNEL_SIDEBAR,
  payload,
});

export const locationSidebar = (payload) => ({
  type: LOCATION_SIDEBAR,
  payload,
});

export const structureSidebar = (payload) => ({
  type: STRUCTURE_SIDEBAR,
  payload,
});

export const editBlockPulseSidebar = (payload) => ({
  type: 'EDIT_BLOCK_PULSE_SIDEBAR',
  payload,
});

export const sidebarNodeAI = (payload) => ({
  type: SIDEBAR_NODE_AI,
  payload,
});
